import React from 'react';
import { ContentWrapper } from '../../components/content_wrapper/content_wrapper';
import { CustomerService } from '../../components/customer_service/customer_service';
import { ScrollToTop } from '../../components/scroll_to_top/scroll_to_top';
import { SEO } from '../../components/seo/seo';

import headerImg from './header.jpg';
import jacob from './jacob.jpg';
import jesse from './jesse.jpg';
import kipp from './kipp.jpg';
import nick from './nick.jpg';
import ricky from './ricky.jpg';

const people = [
  {
    name: 'Kipp Youngquist',
    image: kipp,
    description:
      "Kipp's a fishing fanatic who grew up chasing bass in Minnesota’s rivers and lakes. He’s passionate about teaching others and loves the thrill of catching any game fish.",
  },
  {
    name: 'Jesse Welter',
    image: jesse,
    description:
      'Jesse operates as our warehouse lead and is responsible for the team that manages rapid growth of inventory, orders, and logistics.',
  },
  {
    name: 'Ricky Harris',
    image: ricky,
    description:
      "Ricky, a recent Bethel University grad, competed on multiple national championship bass teams. With over a decade of tournament experience, he's a true expert in the bass fishing world.",
  },
  {
    name: 'Jacob Bros',
    image: jacob,
    description:
      'Jacob grew up in Minnesota fishing for Largemouth and Smallmouth bass. Even outside tournaments, he loves perfecting his bait choices for any situation.',
  },
  {
    name: 'Nick Mraz',
    image: nick,
    description:
      'Nick’s love for fishing began with annual family trips to Lake of the Woods. He joined Omnia in 2021 to help with the warehouse and now spends every chance he gets chasing Largemouth and Smallmouth bass.',
  },
];

export const PersonalShoppingPage = () => {
  return (
    <ScrollToTop>
      <SEO title={'Personal Shopping'} />
      <ContentWrapper>
        <section className="pt-3">
          <section className="bg-[#EEEEE9] flex flex-col-reverse md:flex-row items-center rounded-2xl p-6 mb-16">
            <div className="text-center md:w-1/2 flex flex-col items-center">
              <h1 className="uppercase text-[32px] mb-4 font-black md:pt-16">
                Personal
                <br />
                Shopper
              </h1>
              <p className="text-base mb-6 max-w-[370px]">
                Need help finding the perfect gear? Our crew’s got you covered. Reach out below, and
                we’ll handpick the best stuff for your next adventure. No pressure, no cost—just
                solid recommendations.
              </p>
              <h3 className="font-bold text-2xl mb-2">Get Started Below</h3>
              <CustomerService />
            </div>
            <div className="mb-3 flex justify-center md:w-1/2">
              <div className="md:w-[450px]">
                <img src={headerImg} alt="personal shopping assistant" />
              </div>
            </div>
          </section>
          <section className="text-center pb-6 md:pb-12">
            <h2 className="uppercase text-[32px] mb-4 font-black">How it works</h2>
            <ol className="md:flex">
              <li className="flex flex-col items-center mb-8 px-12 md:w-1/3">
                <div className="bg-[#FF3300] rounded-full font-termina font-bold text-[21px] w-10 h-10 flex items-center justify-center mb-3">
                  1
                </div>
                <div>
                  <p className="font-bold text-xl mb-2">Tell Us What You Need</p>
                  <p>
                    Chat with our experts or send us an email—we’ll help you pick the perfect rod,
                    reel, or tackle.
                  </p>
                </div>
              </li>

              <li className="flex flex-col items-center mb-8 px-12 md:w-1/3">
                <div className="bg-[#FF3300] rounded-full font-termina font-bold text-[21px] w-10 h-10 flex items-center justify-center mb-3">
                  2
                </div>
                <div>
                  <p className="font-bold text-xl mb-2">We’ll Find It</p>
                  <p>
                    Our team of fishing experts will handpick gear options. If you're a PRO member,
                    we’ll even hook you up with exclusive PRO pricing that's not listed on the site.
                  </p>
                </div>
              </li>

              <li className="flex flex-col items-center mb-8 px-12 md:w-1/3">
                <div className="bg-[#FF3300] rounded-full font-termina font-bold text-[21px] w-10 h-10 flex items-center justify-center mb-3">
                  3
                </div>
                <div>
                  <p className="font-bold text-xl mb-2">You Decide</p>
                  <p>
                    Like what you see? Just click to buy. There’s no commitment to purchase, but if
                    you decide before 1 PM CT, your order ships the same day.
                  </p>
                </div>
              </li>
            </ol>
          </section>

          <section className="bg-[#EEEEE9] flex flex-col items-center rounded-2xl p-6 mb-16 text-center">
            <h2 className="uppercase text-[32px] mb-4 font-black">Meet the team</h2>
            <ul className="md:flex md:flex-wrap">
              {people.map((person, index) => (
                <li key={index} className="md:w-1/3 mb-4 md:mb-8">
                  <div className="flex justify-center">
                    <img src={person.image} alt={person.name.toLowerCase()} width={180} />
                  </div>
                  <div className="md:flex md:flex-col items-center">
                    <p className="text-xl mb-3 font-bold">{person.name}</p>
                    <p className="md:max-w-72">{person.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </section>
        </section>
      </ContentWrapper>
    </ScrollToTop>
  );
};

export default PersonalShoppingPage;
